// api/axios.js
import axios from "axios";
const API_URL = "https://api.pori444.com";

const api = axios.create({
  baseURL: `${API_URL}/admin`,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token; // or `Bearer ${token}` if backend expects it
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🚨 Catch 401 globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 🔥 force logout
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // optional: prevent infinite loop
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
